import { io } from 'socket.io-client';

let socket = null;
let connectedToken = null;

function getAccessToken() {
  return localStorage.getItem('accessToken');
}

export function resetChatSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  connectedToken = null;
}

export function getChatSocket() {
  return socket;
}

export function connectChatSocket() {
  const token = getAccessToken();
  if (!token) {
    resetChatSocket();
    return null;
  }

  if (socket?.connected && connectedToken && connectedToken !== token) {
    resetChatSocket();
  }

  if (!socket) {
    socket = io(window.location.origin, {
      path: '/socket.io',
      autoConnect: false,
      transports: ['websocket', 'polling'],
      auth: { token },
    });
  } else {
    socket.auth = { token };
  }

  if (!socket.connected) {
    socket.connect();
  }

  connectedToken = token;
  return socket;
}

export function disconnectChatSocket() {
  resetChatSocket();
}

export function joinChatThread({ userId, psychologistId }) {
  const instance = connectChatSocket();
  if (!instance) {
    return Promise.reject(new Error('Требуется авторизация'));
  }

  return new Promise((resolve, reject) => {
    instance.emit('chat:join', { userId, psychologistId }, (response) => {
      if (response?.ok) {
        resolve(response);
        return;
      }
      reject(new Error(response?.error || 'Не удалось подключиться к чату'));
    });
  });
}

export function leaveChatThread({ userId, psychologistId }) {
  if (!socket?.connected) {
    return;
  }
  socket.emit('chat:leave', { userId, psychologistId });
}

export function sendChatMessage({ userId, psychologistId, text }) {
  const instance = connectChatSocket();
  if (!instance) {
    return Promise.reject(new Error('Требуется авторизация'));
  }

  return new Promise((resolve, reject) => {
    instance.emit('chat:send', { userId, psychologistId, text }, (response) => {
      if (response?.ok) {
        resolve(response.message);
        return;
      }
      reject(new Error(response?.error || 'Не удалось отправить сообщение'));
    });
  });
}

export function subscribeChatMessages(handler) {
  const instance = connectChatSocket();
  if (!instance) {
    return () => {};
  }
  instance.on('chat:message', handler);
  return () => instance.off('chat:message', handler);
}
